import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/provider/$providerId/applications')({
  component: Outlet,
  head: () => ({ meta: [{ title: 'Applications' }] }),
});
